import Router from 'vue-router';
import Vue from 'vue';
import 'nprogress/nprogress.css';

Vue.use(Router);

import Home from '@/components/common/Home.vue';
import { billingRoutes } from '@/router/modules/billing';
import { affiliateRoutes } from '@/router/modules/affiliate';
import { sourceRoutes } from '@/router/modules/source';
import { offerRoutes } from '@/router/modules/offer';
import { productRoutes } from '@/router/modules/product';
import { commonRoutes } from '@/router/modules/common';
import { reportRoutes } from '@/router/modules/report';
import { permitRoutes } from '@/router/modules/permit';

const constantRoutes = [
  {
    path: '/redirect',
    component: Home,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/',
    component: Home,
    redirect: '/Dashboard',
    children: [
      {
        path: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        name: 'Dashboard',
        meta: { title: 'Dashboard' },
      },
    ],
  },
  {
    path: '/clickMixReport',
    component: Home,
    meta: {
      title: 'Click Mix Report',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/report/ClickMixReport.vue'),
        meta: { title: 'Click Mix Report' },
      },
    ],
  },

  {
    path: '/mgn',
    component: Home,
    meta: {
      title: 'Account',
    },
    children: [
      {
        path: 'console-account',
        component: () => import('@/views/account/ConsoleAccount.vue'),
        meta: {
          title: 'Account',
        },
      },
    ],
  },
  {
    path: '/Callback',
    component: Home,
    meta: {
      title: 'Callback Test / Check',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/integration/index.vue'),
        meta: {
          title: 'Callback Test / Check',
        },
      },
    ],
  },
  {
    path: '/Confusion',
    component: Home,
    meta: {
      title: 'Confusion',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/confusion/index.vue'),
        meta: {
          title: 'Confusion',
        },
      },
    ],
  },
  {
    path: '/AffsubLevel',
    component: Home,
    meta: {
      title: 'AffSub Level',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/affSubLevel/index.vue'),
        meta: {
          title: 'AffSub Level',
        },
      },
    ],
  },
  {
    path: '/postbackBilling',
    component: Home,
    meta: {
      title: 'Postback Buckle Billing',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/billing/PostbackBilling.vue'),
        meta: {
          title: 'Postback Buckle Billing',
        },
      },
    ],
  },
  {
    path: '/topList',
    component: Home,
    meta: {
      title: 'Top List',
    },
    children: [
      {
        path: '/',
        component: () => import('@/views/topList/index.vue'),
        meta: {
          title: 'Top List',
        },
      },
    ],
  },
  {
    path: '/af',
    component: Home,
    meta: {
      title: 'Af Simulate',
    },
    children: [
      {
        path: 'simulation',
        component: () => import('@/views/product/AfSimulate.vue'),
        meta: {
          title: 'Af Simulate',
        },
      },
    ],
  },
  {
    path: '/404',
    component: Home,
    meta: {
      title: '404',
    },
    redirect: '/404/',
    children: [
      {
        path: '/',
        component: () => import('@/views/errorPage/404.vue'),
        meta: {
          title: '404',
        },
      },
    ],
  },
  {
    path: '/403',
    component: () => import('@/views/errorPage/403.vue'),
    meta: {
      title: '403',
    },
  },
  {
    path: '/login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
  billingRoutes,
  affiliateRoutes,
  sourceRoutes,
  offerRoutes,
  productRoutes,
  commonRoutes,
  reportRoutes,
  permitRoutes,
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
